export const CONTRACT_STATUSES = ['на подписи', 'в работе', 'архив'] as const;

export type ContractLifecycleStatus = (typeof CONTRACT_STATUSES)[number];

export function contractStatusBadgeVariant(
  status: string | undefined | null,
): 'active' | 'contract' | 'archive' {
  const normalized = status?.trim().toLowerCase();
  if (normalized === 'в работе') return 'active';
  if (normalized === 'архив') return 'archive';
  return 'contract';
}
